import {
  CONTENT,
} from '../../shared/constants/content';
import { CONTENT_DE } from '../../shared/constants/content_de';

export class ContentUseCase {
  private getContent(language: 'en' | 'de' = 'en') {
    return language === 'de' ? CONTENT_DE : CONTENT;
  }

  getMEInfo(language: 'en' | 'de' = 'en') {
    return this.getContent(language).meInfo;
  }

  getFundraiserInfo(language: 'en' | 'de' = 'en') {
    return this.getContent(language).fundraiserInfo;
  }

  getRunningEvents(language: 'en' | 'de' = 'en') {
    return this.getContent(language).runningEvents;
  }

  getRunningEventsPage(language: 'en' | 'de' = 'en') {
    return this.getContent(language).runningEventsPage;
  }

  getAboutUs(language: 'en' | 'de' = 'en') {
    return this.getContent(language).aboutUs;
  }

  getSocialMedia(language: 'en' | 'de' = 'en') {
    return this.getContent(language).socialMedia;
  }

  getMitmachen(language: 'en' | 'de' = 'en') {
    return this.getContent(language).mitmachen;
  }

  getDonationInfo(language: 'en' | 'de' = 'en') {
    return this.getContent(language).donationInfo;
  }

  // Legal content methods
  getLegalContent(language: 'en' | 'de' = 'en') {
    return this.getContent(language).legal;
  }

  getImpressum(language: 'en' | 'de' = 'en') {
    return this.getContent(language).legal.impressum;
  }

  getPrivacyPolicy(language: 'en' | 'de' = 'en') {
    return this.getContent(language).legal.privacy;
  }

  getCookiePolicy(language: 'en' | 'de' = 'en') {
    return this.getContent(language).legal.cookies;
  }

  getCookieBanner(language: 'en' | 'de' = 'en') {
    return this.getContent(language).legal.cookieBanner;
  }

  getAllContent(language: 'en' | 'de' = 'en') {
    return {
      meInfo: this.getMEInfo(language),
      fundraiserInfo: this.getFundraiserInfo(language),
      runningEvents: this.getRunningEvents(language),
      runningEventsPage: this.getRunningEventsPage(language),
      aboutUs: this.getAboutUs(language),
      socialMedia: this.getSocialMedia(language),
      mitmachen: this.getMitmachen(language),
      donationInfo: this.getDonationInfo(language),
      legal: this.getLegalContent(language),
    };
  }
}
